import {
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MobileAppHelperBaseService } from '@fi-shared/fi-shared-services/mobile-app-helper-base.service';

@Component({
    selector: 'fi-btn-upload-file',
    templateUrl: './btn-upload-file.component.html',
    styleUrls: ['./btn-upload-file.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiBtnUploadFileComponent {
    constructor(private mobileAppHelperService: MobileAppHelperBaseService) {}

    @Input() class: string = 'BrandedBackgroundColor';
    @Input() disabled: boolean;
    @Input() accept: string = '';
    @Input() multiple;
    @Input() isNewButton: boolean = false;

    @Output() onFileSelect = new EventEmitter<FileList | Array<Blob>>();

    @ViewChild('inputFile', { static: false }) inputFileElement: ElementRef;
    @ViewChild('deviceMenu', { static: false }) deviceMenu: MatMenu;
    @ViewChild('deviceMenuTrigger', { static: false }) deviceMenuTrigger: MatMenuTrigger;

    @HostBinding('attr.class')
    get attrClass() {
        return 'fi-btn-upload-file';
    }

    selectFileClick() {
        this.inputFileElement.nativeElement.value = '';
        if (this.mobileAppHelperService.mobileAppMode) {
            this.deviceMenuTrigger.openMenu();
        } else {
            this.openFileInput();
        }
    }

    openFileInput() {
        this.inputFileElement.nativeElement.click();
    }

    inputFileChange($event) {
        if ($event.target && $event.target.files.length > 0) {
            this.onFileSelect.emit($event.target.files);
        }
    }

    mobileFileSelected($event) {
        this.onFileSelect.emit($event);
    }
}
